<div class="breadcrumbs-container">
  @for (link of links; track link; let i = $index) {
    <a class="link-item"
      [routerLink]="link.route"
      [queryParams]="getQueryParams(i)"
      [queryParamsHandling]="link.queryParamsHandling">
      <span>{{ link.name }}</span>
      <img alt="" src="assets/icons/chevron_left-Dark-Blue.svg" class="chevron_right-24px">
    </a>
  }
</div>
